// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://moslxznaqtmjyvpzslsg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1vc2x4em5hcXRtanl2cHpzbHNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYwNDM0MjUsImV4cCI6MjA1MTYxOTQyNX0.eFtPRzxGG8w65UqyaT-Xuwt9Hy_AwLP3ey5eIb15JEc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);